import { defineAsyncComponent } from 'vue';

const misaAvaDictionaryPatternRegularPopup = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/popup/misaAvaDictionaryPatternRegularPopup.vue'),
);


const misaAvaCreatePatternRegularView = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaCreatePatternRegularView.vue'),
);

const misaAvaComfirmPatternRegularView = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaComfirmPatternRegularView.vue'),
);


const misaAvaComfirmAutonomyTypePatternRegularView = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaComfirmAutonomyTypePatternRegularView.vue'),
);

const misaAvaViewAutonomyTypePatternRegularView = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaViewAutonomyTypePatternRegularView.vue'), 
);

const misaAvaViewDetailAutonomyTypePatternRegularView = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaViewDetailAutonomyTypePatternRegularView.vue'),
);
const misaAvaViewTreePatternRegularView = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaViewTreePatternRegularView.vue'),
);

const misaAvaLoading = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaLoading.vue'),
);

const misaAvaComfirmPatternRegularWorkBook = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/view/misaAvaComfirmPatternRegularWorkBook.vue'),
);

// popup
const misaAvaViewTreePatternRegularPopup = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/popup/misaAvaViewTreePatternRegularPopup.vue'),
);
const misaAvaComfirmAutonomyTypePatternRegularPopup = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/popup/misaAvaComfirmAutonomyTypePatternRegularPopup.vue'),
);

const misaAvaViewAutonomyTypePatternRegularViewEditPopup = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/popup/misaAvaViewAutonomyTypePatternRegularViewEditPopup.vue'),
);

const misaAvaDictionaryPatternRegularAddSubItemsPopup = defineAsyncComponent(() =>
  import('@/views/misaAva/dictionaryPatternRegular/popup/misaAvaDictionaryPatternRegularAddSubItemsPopup.vue'),
);

export function registerMisaAva(app) {
  app.component('misaAvaDictionaryPatternRegularAddSubItemsPopup', misaAvaDictionaryPatternRegularAddSubItemsPopup);
  app.component('misaAvaDictionaryPatternRegularPopup', misaAvaDictionaryPatternRegularPopup);
  app.component('misaAvaCreatePatternRegularView', misaAvaCreatePatternRegularView);
  app.component('misaAvaComfirmPatternRegularView', misaAvaComfirmPatternRegularView);
  app.component('misaAvaComfirmAutonomyTypePatternRegularView', misaAvaComfirmAutonomyTypePatternRegularView);
  app.component('misaAvaViewAutonomyTypePatternRegularView', misaAvaViewAutonomyTypePatternRegularView);
  app.component('misaAvaViewDetailAutonomyTypePatternRegularView', misaAvaViewDetailAutonomyTypePatternRegularView);
  app.component('misaAvaViewTreePatternRegularView', misaAvaViewTreePatternRegularView);
  app.component('misaAvaLoading', misaAvaLoading);
  app.component('misaAvaViewTreePatternRegularPopup', misaAvaViewTreePatternRegularPopup);
  app.component('misaAvaViewAutonomyTypePatternRegularViewEditPopup', misaAvaViewAutonomyTypePatternRegularViewEditPopup);
  app.component('misaAvaComfirmAutonomyTypePatternRegularPopup', misaAvaComfirmAutonomyTypePatternRegularPopup);
  app.component('misaAvaComfirmPatternRegularWorkBook', misaAvaComfirmPatternRegularWorkBook);
}
